import angular from 'angular';

import DATAPIController from './dat-api.controller';

export default angular.module('autoboard.datAPIComponent', [])
  .controller('DATAPIController', DATAPIController)
  .name;
